module.exports = __webpack_public_path__ + "img/A12.a50de8c4.png";